export default __webpack_public_path__ + "5a4f4c664490a1907c5c98d52c75af43.png";